import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { GrocyRegisteredPurchaseRequest } from '../../entities/grocy/registered-purchases/registered-purchase-request.entity';
import { GrocyRegisteredPurchase } from '../../entities/grocy/registered-purchases/registered-purchase.entity';
import { BaseApi } from '../base.api';

@Injectable({
  providedIn: 'root',
})
export class GrocyRegisteredPurchasesApi extends BaseApi {
  endpoint = 'grocy/registered-purchases';

  clearCache(): Observable<void> {
    return this.http.delete<void>(this.generateUrl('cache')).pipe(catchError(e => this.handleError(e)));
  }

  registerPurchase(registedPurchaseRequest: GrocyRegisteredPurchaseRequest): Observable<GrocyRegisteredPurchase[]> {
    return this.http
      .post<GrocyRegisteredPurchase[]>(this.generateUrl(), registedPurchaseRequest)
      .pipe(catchError(e => this.handleError(e)));
  }
}
